//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const ONE_MINUTE_IN_MS = 1000 * 60;
  const FIVE_MINUTES_IN_MS = 1000 * 60 * 5;

  angular.module('curalate').directive('relativeTime', [
    '$interval',
    '$filter',
    'DateTimeService',
    function(
            $interval,
            $filter,
            DateTimeService,
        ) {
      const calculateRelativeTime = function(time) {
        return moment(time).from(DateTimeService.userNow());
      };

      return function(scope, element, attrs) {
        const time = attrs.relativeTime;
        const formattedTime = calculateRelativeTime(time);

                // Update datetime immediately
        element.text(formattedTime);

                // Update datetime dynamically - we'll update datetimes more often if it is less than an hour ago
        const heartbeat = (formattedTime.indexOf('second') !== -1 || formattedTime.indexOf('minute') !== -1) ? ONE_MINUTE_IN_MS : FIVE_MINUTES_IN_MS;

        const intervalId = $interval(() => {
          element.text(calculateRelativeTime(time));
        }, heartbeat);

                // Cleanup
        element.bind('$destroy', () => {
          $interval.cancel(intervalId);
        });
      };
    }]);
})();
